module.exports = "<h2 id=\"privacy-policy\">Privacy Policy</h2>\n<p>Superset is a serverless, read-only client for <a href=\"https://developers.google.com/fit/\">Google&#39;s Fitness API</a>. As such we do not collect or store any data about our visitors. You can read the Google Fit terms of service <a href=\"https://www.google.com/intl/zh_TW/fit/tos.html\">here</a>.</p>\n<p>The only user-specific data used by the application, such as your app settings, are stored client-side in your browser&#39;s local storage, where they are only accessible by you and can be cleared at any time.</p>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/content/privacy.md
// module id = HdQG
// module chunks = 8